<template>
  <div
    class="z-modal"
    :class="{show}"
  >
    <div class="z-modal__body">
      <div class="z-modal__content">
        <a
          href="#"
          class="z-modal__close"
          @click.prevent="close"
        >
          <i class="icon icon-close" />
        </a>
        <div
          v-if="title"
          class="z-modal__title"
        >
          <slot name="title" />
        </div>
        <div
          class="z-modal__text"
        >
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    show: false,
    title: '',
    message: '',
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel',
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  watch: {
    show(val) {
      if (val) {
        document.querySelector('body').classList.add('hide-scroll');
      } else {
        document.querySelector('body').classList.remove('hide-scroll');
      }
    },
  },

  methods: {
    open(options = {}) {
      this.title = options.title;
      this.message = options.message;
      if (options.confirmButtonText) {
        this.confirmButtonText = options.confirmButtonText;
      }
      if (options.cancelButtonText) {
        this.cancelButtonText = options.cancelButtonText;
      }
      this.show = true;
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    close() {
      this.show = false;
      this.$emit('close');
    },
  },
};
</script>
